// project import
import home from './home';
import settings from './settings';
import dataAnalytics from './data-analytics';
import help from './help';
import faqs from './faqs';
import videoAi from './video-ai';
import messagesDashboard from './message-center';
import { crm } from './crm';
import { collaborations } from './collaborations';
import { affiliateCommunity, simplifiedAffiliateCommunity } from './affiliate-community';

// types
import { NavItemType } from '@trendiolive/trendio-selfcare-ui-kit';

// ==============================|| MENU ITEMS ||============================== //

const allMenuItems: { items: NavItemType[] } = {
  items: [home, affiliateCommunity, collaborations, crm, messagesDashboard, simplifiedAffiliateCommunity, videoAi, dataAnalytics, faqs, help, settings]
};

export default allMenuItems;
